import React from 'react';
import {
    CategoryBrowseProviderProps,
    CategoryBrowseProviders,
} from './CategoryBrowseProviders';
import { CategoryBrowseBasePage } from './pages/CategoryBrowseBasePage';
import { CategoryBrowsePage } from './pages/CategoryBrowsePage';
import { NightlifePage } from './pages/NightlifePage';
import { SeasonalPage } from './pages/SeasonalPage';

export const CategoryBrowsePageWithProviders: React.FunctionComponent<
    CategoryBrowseProviderProps
> = (props) => {
    const { category } = props.match.params;
    const TagAsCategoryPages: { [key: string]: React.FunctionComponent } = {
        nightlife: NightlifePage,
        ...(props.featureFlags?.enableSeasonalModule && {
            seasonal: SeasonalPage,
        }),
    };
    const BrowsePage = TagAsCategoryPages[category] || CategoryBrowsePage;
    return (
        <CategoryBrowseProviders
            match={props.match}
            location={props.location}
            history={props.history}
            location_data={props.location_data}
            location_slug={props.location_slug}
            featureFlags={props.featureFlags}
        >
            <CategoryBrowseBasePage {...props}>
                <BrowsePage />
            </CategoryBrowseBasePage>
        </CategoryBrowseProviders>
    );
};

export default CategoryBrowsePageWithProviders;
